import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import * as React from 'react';
import { userSession } from 'state/session';
import { user } from 'utils/auth/user';
import { classNames } from 'utils/ui/css';

export default function DealerIdSelectionMenu({
  popoverColor = 'var(--ex3d-adjunct-bg-color)',
}: {
  svgClassname?: string;
  popoverColor?: string;
}) {
  const session = userSession().useState();
  const disabled = session.isShared;
  const [currentDealerId, setCurrentDealerId] = React.useState(user.dealerId);

  const changeDealerId = (newDealerId: string) => {
    user.dealerId = newDealerId;
    setCurrentDealerId(newDealerId);
  };

  const canShowMenu = user.dealerIdsList.length > 1;

  return canShowMenu ? (
    <Popover className="relative" part="dealer-id-selection">
      <PopoverButton
        className={classNames(
          'inline-flex items-center gap-x-1 text-sm/10 font-semibold',
          disabled && 'opacity-50 cursor-not-allowed'
        )}
        disabled={disabled}
      >
        <span className="ex3d-button-text">{currentDealerId}</span>
      </PopoverButton>

      <PopoverPanel
        transition
        className="absolute left-1/2 z-[101] mt-1 flex w-screen max-w-min -translate-x-1/2 px-4 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
      >
        {({ close }) => (
          <div
            className="w-auto min-w-56 shrink rounded-md bg-teal p-4 text-sm/10 font-semibold text-white shadow-lg empty:hidden"
            style={{ backgroundColor: popoverColor }}
          >
            {user.dealerIdsList.map((dealerId) => {
              return (
                <button
                  key={dealerId}
                  onClick={() => {
                    changeDealerId(dealerId);
                    close();
                  }}
                  role="button"
                  className="flex w-full p-2 text-left hover:text-neon-100"
                >
                  <span className="grow">{dealerId}</span>
                </button>
              );
            })}
          </div>
        )}
      </PopoverPanel>
    </Popover>
  ) : null;
}
